/**
 * Wasm two-buffered array for multi-threading
 */
export class WasmBufferedArray {
    _frontBuffer;
    _backBuffer;
    /**
     * Create a new wasm buffered array
     * @param frontBuffer Front buffer
     * @param backBuffer Back buffer
     */
    constructor(frontBuffer, backBuffer) {
        this._frontBuffer = frontBuffer;
        this._backBuffer = backBuffer ?? frontBuffer;
    }
    /**
     * Set back buffer
     *
     * This method should be called once before starting multi-threading
     * @param backBuffer Back buffer
     */
    setBackBuffer(backBuffer) {
        this._backBuffer = backBuffer;
    }
    /**
     * Swap front and back buffers
     *
     * Span objects created from the front buffer will be automatically updated
     */
    swap() {
        const temp = this._backBuffer;
        this._backBuffer = this._frontBuffer;
        this._frontBuffer = temp;
    }
    /**
     * Get front buffer
     */
    get frontBuffer() {
        return this._frontBuffer.array;
    }
    /**
     * Get back buffer
     */
    get backBuffer() {
        return this._backBuffer.array;
    }
}
/**
 * Wasm two-buffered array span for multi-threading
 */
export class WasmBufferedArraySpan {
    _data;
    _frontBufferPtr;
    _frontBufferSpan;
    _backBufferSpan;
    /**
     * Create a new wasm buffered array span
     * @param wasmInstance MMD WASM instance
     * @param data Wasm buffered array
     * @param byteOffset Byte offset relative to the buffer
     * @param length Length of the span
     */
    constructor(wasmInstance, data, byteOffset, length) {
        this._data = data;
        const frontBufferPtr = this._frontBufferPtr = data.frontBuffer.byteOffset;
        this._frontBufferSpan = wasmInstance.createTypedArray(data.frontBuffer.constructor, frontBufferPtr + byteOffset, length);
        const backBufferPtr = data.backBuffer.byteOffset;
        this._backBufferSpan = wasmInstance.createTypedArray(data.backBuffer.constructor, backBufferPtr + byteOffset, length);
    }
    /**
     * Update back buffer reference
     *
     * This method should be called once before starting multi-threading when the back buffer is not initialized
     * @param wasmInstance MMD WASM instance
     */
    updateBackBufferReference(wasmInstance) {
        const frontBufferSpan = this._frontBufferSpan.array;
        const byteOffset = frontBufferSpan.byteOffset - this._frontBufferPtr;
        const length = frontBufferSpan.length;
        const backBufferPtr = this._data.backBuffer.byteOffset;
        this._backBufferSpan = wasmInstance.createTypedArray(this._data.backBuffer.constructor, backBufferPtr + byteOffset, length);
    }
    /**
     * Get front buffer span
     */
    get array() {
        if (this._frontBufferPtr !== this._data.frontBuffer.byteOffset) {
            this._frontBufferPtr = this._data.frontBuffer.byteOffset;
            const temp = this._backBufferSpan;
            this._backBufferSpan = this._frontBufferSpan;
            this._frontBufferSpan = temp;
        }
        return this._frontBufferSpan.array;
    }
}
